/** Shortest distance from (x, z) to a polyline. */
export function distToPolyline(x: number, z: number, pts: [number, number][]): number {
  let best = Number.POSITIVE_INFINITY;
  for (let i = 1; i < pts.length; i++) {
    const [ax, az] = pts[i - 1] as [number, number];
    const [bx, bz] = pts[i] as [number, number];
    const dx = bx - ax;
    const dz = bz - az;
    const len2 = dx * dx + dz * dz || 1;
    const t = Math.max(0, Math.min(1, ((x - ax) * dx + (z - az) * dz) / len2));
    best = Math.min(best, Math.hypot(x - (ax + dx * t), z - (az + dz * t)));
  }
  return best;
}
